import { type FC } from 'react';
import { useWatchNewPayinTickets } from '~/features/payin';

export const PayinTicketsWatcher: FC = () => {
    useWatchNewPayinTickets();

    return null;
};
